import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  AddConsultantModel,
  CreateConsultantModel,
  RemoveConsultantModel,
  SearchConsultantModel,
} from '../../../models/consultant.model'

@Injectable({
  providedIn: 'root',
})
export class ConsultantService {
  private baseUrl = environment.baseUrl
  private resource = 'Consultor'
  private resourceClient = 'ConsultorCliente'

  constructor(private httpClient: HttpClient) {}

  public createConsultant(
    model: CreateConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/create`,
      model,
    )
  }

  public editConsultant(
    model: any,
    // model: EditConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/edit`,
      model,
    )
  }

  public deleteConsultant(
    model: any,
    // model: DeleteConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete`,
      model,
    )
  }

  public listPagedConsultant(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listConsultant(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public searchConsultant(
    model: SearchConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public getConsultantbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedConsultant(
    page: number,
    rows = 15,
    model: SearchConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  ////////////////// Consultant Client //////////////////

  public addConsultantClient(
    model: AddConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/Cliente/add`,
      model,
    )
  }

  public editConsultantClient(
    model: any,
    // model: EditConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/edit`,
      model,
    )
  }

  public removeConsultantClient(
    model: RemoveConsultantModel,
    // model: DeleteConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/remove`,
      model,
    )
  }

  public listPagedConsultantClient(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedConsultantClientById(
    idConsultant: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/ClientesByConsultor/listpaginated/${idConsultant}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedConsultantNotClientById(
    idConsultant: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/NaoClientes/listpaginated/${idConsultant}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchPagedConsultantNotClient(
    page: number,
    rows: number = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/NaoClientes/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchPagedConsultantClient(
    page: number,
    rows: number = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Clientes/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public listPagedConsultantByPerson(
    idPerson: number,
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/ConsultorByCliente/listpaginated/${idPerson}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedClientConsultant(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listConsultantClient(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/listall`,
    )
  }

  public listConsultantClientByPerson(
    idPerson: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/ConsultorByCliente/list/${idPerson}`,
    )
  }

  public listClientConsultant(
    idConsultant: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/ClientesByConsultor/list/${idConsultant}`,
    )
  }

  public searchClientConsultant(
    model: SearchConsultantModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/search`,
      model,
    )
  }

  public getClientConsultantbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/${id}`,
    )
  }

  public searchPagedClientConsultant(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/Consultor/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public searchPagedClientConsultantByClientId(
    page: number,
    rows = 15,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceClient}/Consultor/Cliente/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
